import { Action } from "../actions/types"
import { VehicleDocumentType, VehicleDocumentActionList } from "../actions/vehicleDocumentActions"

const initialValue: Array<VehicleDocumentType> = []

const vehicleDocumentReducer = (state: Array<VehicleDocumentType> = initialValue, action: Action) => {
    switch (action.type) {

        case VehicleDocumentActionList.ADD_VEHICLE_DOCUMENT:
            return [
                ...state,
                action.data,
            ]

        case VehicleDocumentActionList.UPDATE_VEHICLE_DOCUMENT:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case VehicleDocumentActionList.FETCH_VEHICLE_DOCUMENT:
            return action.data

        case VehicleDocumentActionList.DELETE_VEHICLE_DOCUMENT:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default vehicleDocumentReducer